// Copyright 2022 - 2023 Fewcha. All rights reserved.

export type SocialItemType = {
  name: string;
  icon: string;
  url: string;
};

export type TokenType = {
  tier: string;
  image: string;
  name: string;
  description: string[];
};

export const emptyTokenType: TokenType = {
  tier: "",
  image: "",
  name: "",
  description: [],
};

export type WalletType = {
  publicKey: string;
  address: string;

  balance: string;

  isConnected: boolean;
  network: string;
};

export type BenefitType = { label: string; countLevel: string };

export type BaseType = {
  MODULE_ADDRESS: string;
  COLLECTION_CREATOR: string;
  BASE_URL: string;
  FIREBASE_CONFIG: string;
  NETWORK_NAME: string;
  NETWORK_URL: string;
  STAGE: string;
  CONFIG_URL: string;
  EVENT_URL: string;
  NOTICE: string;
  COLLECTION_NAME: string;
};

export const base: BaseType = {
  MODULE_ADDRESS: process.env.REACT_APP_MODULE_ADDRESS!,
  COLLECTION_CREATOR: process.env.REACT_APP_COLLECTION_CREATOR!,
  BASE_URL: process.env.REACT_APP_BASE_URL!,
  FIREBASE_CONFIG: JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG!),
  NETWORK_NAME: process.env.REACT_APP_NETWORK_NAME!,
  NETWORK_URL: process.env.REACT_APP_NETWORK_URL!,
  STAGE: process.env.REACT_APP_STAGE!,
  CONFIG_URL: "",
  EVENT_URL: "",
  NOTICE: "",
  COLLECTION_NAME: "Fewcha DAO Rings",
};

base.CONFIG_URL = `https://config.fewcha.io/memberships-${base.STAGE}/config.json`;
base.EVENT_URL = `https://config.fewcha.io/memberships-${base.STAGE}/event.json`;

export const socials: SocialItemType[] = [
  // {
  //   name: "Discord",
  //   icon: `https://config.fewcha.io/memberships-${base.STAGE}/socials/discord.svg`,
  //   url: "https://discord.com/invite/fewcha",
  // },
  {
    name: "Twitter",
    icon: `https://config.fewcha.io/memberships-${base.STAGE}/socials/twitter.svg`,
    url: "https://twitter.com/fewchawallet",
  },
];

export const tokens: TokenType[] = [
  {
    tier: "1",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-1-200.gif`,
    name: "Ring of Space",
    description: ["Ring of Space", "Tier 1 Airdrop $FCH", "Tier 1 Membership Perks"],
  },
  {
    tier: "2",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-2-200.gif`,
    name: "Ring of Mind",
    description: ["Ring of Mind", "Tier 2 Airdrop $FCH", "Tier 2 Membership Perks"],
  },
  {
    tier: "3",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-3-200.gif`,
    name: "Ring of Reality",
    description: ["Ring of Reality", "Tier 3 Airdrop $FCH", "Tier 3 Membership Perks"],
  },
  {
    tier: "4",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-4-200.gif`,
    name: "Ring of Evolution",
    description: ["Ring of Evolution", "Tier 4 Airdrop $FCH", "Tier 4 Membership Perks"],
  },
  {
    tier: "5",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-5-200.gif`,
    name: "Ring of Decentralization",
    description: ["Ring of Decentralization", "Tier 5 Airdrop $FCH", "Tier 5 Membership Perks"],
  },
  {
    tier: "6",
    image: `https://config.fewcha.io/memberships-${base.STAGE}/tokens/token-tier-6-200.gif`,
    name: "Ring of Future",
    description: ["Ring of Future", "Tier 6 Airdrop $FCH", "Tier 6 Membership Perks"],
  },
];

export const benefits: BenefitType[] = [
  {
    label: "Governance proposals",
    countLevel: "123456",
  },
  {
    label: "Platform token airdrop",
    countLevel: "123456",
  },
  {
    label: "Platform whitelist & early access",
    countLevel: "23456",
  },
  {
    label: "Exclusive NFT Releases",
    countLevel: "456",
  },
  {
    label: "Exclusive Airdrop and early access",
    countLevel: "56",
  },
  {
    label: "Elite Club membership events",
    countLevel: "6",
  },
];

export type ConfigReducer = {
  base: BaseType;
  socials: SocialItemType[];
  tokens: TokenType[];
  benefits: BenefitType[];
};

export const defaultConfigReducer: ConfigReducer = {
  base,
  socials,
  tokens,
  benefits,
};
